import { useValidation } from '@eti/providers';
import { Checkbox as EtiCheckbox } from '@etg/wings';
import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
const mapPropsToProps = ({
  className,
  'data-testid': dataTestId,
  id,
  input,
  hasError,
  name,
  required
}) => ({
  checked: Boolean(input.value),
  className,
  'data-testid': dataTestId,
  hasError,
  id,
  name,
  onChange: input.onChange,
  required
});
const Checkbox = props => /*#__PURE__*/_jsx(EtiCheckbox, {
  ...mapPropsToProps(props)
});
const CheckboxField = ({
  className,
  'data-testid': dataTestId,
  formatGet,
  formatSet,
  hasError,
  id,
  name,
  onChange,
  required,
  validationRuleName
}) => {
  const validate = useValidation(validationRuleName);
  return /*#__PURE__*/_jsx(Field, {
    component: Checkbox,
    format: formatGet,
    name: name,
    normalize: formatSet,
    onChange: onChange,
    props: {
      className,
      'data-testid': dataTestId,
      hasError,
      id,
      name,
      required
    },
    validate: validate
  });
};
export default CheckboxField;
//# sourceMappingURL=Checkbox.js.map